import { clsx } from "clsx";
import React, { type PropsWithChildren } from "react";
import { useI18n } from "../../utils/hooks/use.i18n";
import Styles from "./Modal.module.css";
import { useModalContext } from "./ModalContext";

interface ModalHeaderProps {
  onClose?: () => void;
}

export const ModalHeader = ({
  children,
  onClose,
}: PropsWithChildren<ModalHeaderProps>) => {
  const t = useI18n("CLOSE_BUTTON.");

  const { backgroundColor } = useModalContext();

  return (
    <div
      className={clsx(
        Styles.modalHeaderContainer,
        backgroundColor && [
          "background",
          backgroundColor.isDark() ? "theme-dark" : "theme-light",
        ],
      )}
    >
      <div className={Styles.modalHeader}>{children}</div>
      {onClose && (
        <button
          className={Styles.modalClose}
          onClick={onClose}
          title={t("CLOSE")}
          type="button"
        >
          <span className="hoylu-ui-icons-incomplete" />
        </button>
      )}
    </div>
  );
};
